import {createSlice} from "@reduxjs/toolkit";
import moment from "moment";

let date = new Date();
const currentTime = moment().format("HH:mm");

export const newSalesInitialValue = {
    documentType: "",
    documentTypeName: "",
    myDataType: "",
    date: date,
    time: currentTime,
    customTime: "false",
    installation: "",
    preNumber: "",
    numberingMode: "manual",
    number: "",
    corelatedDocument: "",
    sourceQuotation: "",
    sourceQuotationName: "",
    client: "",
    clientName: "",
    clientInstallationId: 0,
    clientInstallationType: "",
    clientCode: "",
    newClient: "",
    email: "",
    phone: "",
    clientType: "Existing", // Existing or New
    vat: "",
    address: "",
    doy: "",
    city: "",
    pc: "",
    paymentType: "",
    paymentTypeName: "",
    myDataPaymentId: "",
    bankAccount: "",
    salePurpose: "",
    specialInvoiceCategory: "",
    isDeliveryNote: false,
    products: [],
    packingsDeclarations: [],
    otherCorrelatedEntities: [],
    extraData: {
        wayOfSendingGoods: "",
        wayOfSendingGoodsName: "",
        carNumber: "",
        carNumberName: "",
        goodsSendDate: "",
        otherTax: "",
        otherTaxEuro: "",
        withHoldTax: "",
        withHoldTaxEuro: "",
        fee: "",
        feeEuro: "",
        stamp: "",
        stampEuro: "",
        deductionsEuro: "0.00",
        deliveryLocation: "companyLocation",
        locationAddress: "",
        locationCity: "",
        locationCountry: "",
        locationZip: "",
        locationVatNumber: "",
        locationCompanyName: "",
        cashRegister: "",
        isTriangularTrade: "false",
        isRegime4200: "false"
    },
    notes: "",
    salesTaxes: [],
    totalQuantity: 0,
    totalBeforeDiscount: 0,
    totalDiscount: 0,
    totalNetValue: 0,
    totalVatValue: 0,
    totalAmount: 0,
    paymentAmount: 0,
    tipAmount: 0, // Not saved in the database
    sendEmail: "inactive",
    emailRecipients: [],
    myDataStatus: "not_sent",
    enablePeppol: "inactive",
    htmlContent: "",
    transmissionFailure: "",
    documentCategory: "Initial Document",
}

export const newSalesNewProductInitialValue = {
    no: "",
    id: 0,
    code: "",
    name: "",
    quantity: 1,
    mu: "",
    unitPrice: "",
    discount: "",
    isPerDiscount: "false",
    isDiscountAmount: "true",
    fee: "",
    feeEuro: "",
    otherTax: "",
    stamp: "",
    stampEuro: "",
    taxes: "",
    vatPercentage: "",
    vatId: "",
    vatReason: "",
    vatType: "",
    withHoldTax: "",
    withHoldTaxEuro: "",
    otherTaxEuro: "",
    vat: "",
    netValue: "",
    totalValue: "",
    _id: ""
}

const initialSalesDiscountObject = {
    discountType: "percentage",
    amount: 0,
    discountAsLine: false,
    discountAsLineText: "",
}

export const newQuotationInitialValue = {
    documentType: "",
    documentTypeName: "",
    date: date,
    time: currentTime,
    installation: "",
    preNumber: "",
    numberingMode: "manual",
    number: "",
    corelatedDocument: "",
    client: "",
    clientName: "",
    clientInstallationId: 0,
    clientInstallationType: "",
    clientCode: "",
    newClient: "",
    email: "",
    phone: "",
    clientType: "Existing", // Existing or New
    vat: "",
    address: "",
    doy: "",
    city: "",
    pc: "",
    paymentType: "",
    paymentTypeName: "",
    myDataPaymentId: "",
    bankAccount: "",
    salePurpose: "",
    specialInvoiceCategory: "",
    isDeliveryNote: false,
    products: [],
    extraData: {
        wayOfSendingGoods: "",
        wayOfSendingGoodsName: "",
        carNumber: "",
        carNumberName: "",
        goodsSendDate: "",
        otherTax: "",
        otherTaxEuro: "",
        withHoldTax: "",
        withHoldTaxEuro: "",
        fee: "",
        feeEuro: "",
        stamp: "",
        stampEuro: "",
        deductionsEuro: "0.00",
        deliveryLocation: "companyLocation",
        locationAddress: "",
        locationCity: "",
        locationCountry: "",
        locationZip: "",
        locationVatNumber: "",
        locationCompanyName: "",
        cashRegister: "",
    },
    salesTaxes: [],
    notes: "",
    totalQuantity: 0,
    totalBeforeDiscount: 0,
    totalDiscount: 0,
    totalNetValue: 0,
    totalVatValue: 0,
    totalAmount: 0,
    paymentAmount: 0,
    tipAmount: 0, // Not saved in the database
    sendEmail: "inactive",
    emailRecipients: [],
    htmlContent: "",
    transmissionFailure: "",
    documentCategory: "Initial Document",
    status: "unused"
}

const newQuotationNewProductInitialValue = {
    no: "",
    id: 0,
    code: "",
    name: "",
    quantity: 1,
    mu: "",
    unitPrice: "",
    discount: "",
    isPerDiscount: "false",
    isDiscountAmount: "true",
    fee: "",
    feeEuro: "",
    otherTax: "",
    stamp: "",
    stampEuro: "",
    taxes: "",
    vatPercentage: "",
    vatId: "",
    vatReason: "",
    vatType: "",
    withHoldTax: "",
    withHoldTaxEuro: "",
    otherTaxEuro: "",
    vat: "",
    netValue: "",
    totalValue: "",
    _id: ""
}

const initialQuotationDiscountObject = {
    discountType: "percentage",
    amount: 0,
    discountAsLine: false,
    discountAsLineText: "",
}

export const newPrimerAiUrlInitialValue = {
    vatNumber: "",
    erpVersion: "",
    numberOfUsers: "1",
    numberOfEmployees: "",
    dclRental: false,
    dclParking: false,
    dclGarage: false,
    cloudCapacity: "",
    accountsNumber: "",
    b2g: false,
    myDataReport: false,
    deliveryNote: false,
    creditsPerMonth: "",
    limitCompanies: "",
    documentsPerMonth: "500",
    price: "0",
    vat: "0",
    total: "0",
    billingInterval: "1",
    billingPeriod: "month",
    advance: "0",
    monthOfSecondInstallment: "2",
    linkExpireAfter: moment().add(7, "days").toDate(),
    sentLinkToEmail: false,
    email: "",
    generatedUrl: "",
    userId: "",
    user: "",
    company: ""
}

export const defaultSalesMyDataReportRequestData = {
    date_from: moment().startOf("month").format("DD/MM/YYYY"),
    date_to: moment().endOf("month").format("DD/MM/YYYY"),
    clientVAT: "",
    number_from: "",
    number_to: "",
    invoiceType: [],
    aiStatus: [],
    showFilter: "all",
    invoicesFromChannel: "all",
    reportType: "sales",
    totalSum_from: "",
    totalSum_to: "",
    showClients: false,
    showAccounting: true,
    page: 1,
    totalPages: 0,
    totalItems: 0,
    lastUpdate: "",
    classified: "",
    marks: "",
    classificationTypes: [],
}

const salesBalanceSheetInitRequestData = {
    page: 1,
    date_from: "",
    date_to: "",
    clientId: "",
    clientName: "",
    invoiceType: [],
    paymentType: [],
    carNumber: [],
    providerChannel: [],
    productName: "",
    totalSum_from: "",
    totalSum_to: "",
    preNumber_from: "",
    preNumber_to: "",
    numberFrom: "",
    numberTo: "",
    myDataStatus: [],
    paymentStatus: [],
    notes: "",
    installation: "",
    country: "",

    totalPages: 0,
    totalVatValue: 0,
    totalNetValue: 0,
    totalValue: 0,
}

const initClientPaymentsReportRequestData = {
    firstLoad: true, // For date setup
    date_from: "",
    date_to: "",
    numberFrom: "",
    numberTo: "",
    amountFrom: "",
    amountTo: "",
    notes: "",
    page: 1,
    clientName: "",
    invoiceType: [],
    paymentType: [],
}

const initClientPaymentsReportResponseData = {
    totalPages: 0,
    data: [],
    totalPaymentAmount: 0,
}

const initSalesGraphicReportRequestData = {
    firstLoad: true, // For date setup
    date_from: "",
    date_to: "",
    clientId: "",
    clientName: "",
    paymentType: [],
}

const initSalesGraphicReportResponseData = {
    data: [],
}

const initSalesMonthlyTurnoverRequestData = {
    page: 1,
    date_from: "",
    date_to: "",
    clientName: "",
}

const initSalesMonthlyTurnoverResponseData = {
    totalPages: 0,
    data: [],
    totalPaymentAmount: 0,
}

const initialState = {
    sales: [],
    quotations: [],
    searchSales: [],
    searchQuotations: [],
    searchAIQuotations: [],
    correlatedDclData: {},
    correlatedVisitData: {},
    correlatedSaleData: {},
    correlatedQuotationData: {},
    totalItemsSS: 0,
    perPageSS: 0,
    totalItemsQQ: 0,
    perPageQQ: 0,
    totalItemsAIQQ: 0,
    perPageAIQQ: 0,
    newSalesInitialValue: newSalesInitialValue,
    newSales: newSalesInitialValue,
    newQuotations: newQuotationInitialValue,
    newQuotationInitialValue: newQuotationInitialValue,
    newSalesNewProductInitialValue: newSalesNewProductInitialValue,
    newQuotationNewProductInitialValue: newQuotationNewProductInitialValue,
    editQuotationNewProductInitialValue: newQuotationNewProductInitialValue,
    newSalesNewProduct: newSalesNewProductInitialValue,
    newQuotationNewProduct: newQuotationNewProductInitialValue,
    newPrimerAiUrl: newPrimerAiUrlInitialValue,
    newPrimerAiUrlInitialValue: newPrimerAiUrlInitialValue,
    editSales: {
        "0": newSalesInitialValue
    },
    editQuotations: {
        "0": newQuotationInitialValue
    },
    editSalesNewProductInitialValue: newSalesNewProductInitialValue,
    editSalesNewProduct: newSalesNewProductInitialValue,
    salesTemplates: [],
    quotationsTemplates: [],
    primerAiUrlTemplates: [],
    selectedSalesTemplate: {},
    selectedQuotationsTemplate: {},
    corelatedDocumentsList: [],
    selectedPrimerAiUrl: newPrimerAiUrlInitialValue,

    printLayout: '',

    salesDiscountObject: initialSalesDiscountObject,
    quotationDiscountObject: initialQuotationDiscountObject,

    newSaleClientCustomData: {
        clientVatCategory: "Normal VAT",
        clientVatReason: "",
        clientCustomVat: 0,
    },

    newQuotationClientCustomData: {
        clientVatCategory: "Normal VAT",
        clientVatReason: "",
        clientCustomVat: 0,
    },

    editQuotationClientCustomData: {
        clientVatCategory: "Normal VAT",
        clientVatReason: "",
        clientCustomVat: 0,
    },

    // Sales Balance Sheet
    salesBalanceReportRequestData: {},
    salesBalanceReportData: {},

    // Sales Monthly Turnover Report
    salesMonthlyTurnoverReportRequestData: {},
    salesMonthlyTurnoverReportData: {},

    // Sale My Data Report
    forceRefreshMyDataSalesReport: "",
    defaultSalesMyDataReportRequestData: defaultSalesMyDataReportRequestData,
    salesMyDataReportRequestData: defaultSalesMyDataReportRequestData,
    salesMyDataReportData: [],
    salesMyDataReportClientsData : [],
    salesMyDataReportTotals: {
        totalNetValue: 0,
        totalVatValue: 0,
        totalValue: 0,
        totalCount: 0,
        totalNetValueMyData: 0,
        totalVatValueMyData: 0,
        totalValueMyData: 0,
        totalCountMyData: 0,
    },

    // View sale peppol quick edit
    viewSalePeppolEdit: {
        "0": false,
    },
    viewSalePeppolEditOldData: {
        "0": {},
    },

    // Primer Client Payments
    primerClientPaymentsRequestData: {
        extraInfo: {},
        clientPaymentsData: [],
        documentType: "",
        paymentType: "",
        paymentTypeType: "",
        bankOrPOS: "",
        preNumber: "",
        numberFrom: "",
        numberTo: "",
        date: moment().format("DD/MM/YYYY"),
    },

    // Emron Client Payments
    emronClientPaymentsRequestData: {
        extraInfo: {},
        clientPaymentsData: [],
        documentType: "",
        paymentType: "",
        paymentTypeType: "",
        bankOrPOS: "",
        preNumber: "",
        date: moment().format("DD/MM/YYYY"),
    },

    // Client Payments Report
    clientPaymentsReportRequestData: {},
    clientPaymentsReportResponseData: {},

    // Sales Graphic Report
    salesGraphicReportRequestData: {},
    salesGraphicReportResponseData: {},

    aiQuotationsRequestData: {
        page: 1,
        user: "",
        dateFrom: moment().startOf("month").format("DD/MM/YYYY"),
        dateTo: moment().endOf("month").format("DD/MM/YYYY"),
    },
    aiQuotationsResponseData: {
        data: [],
        totalPages: 0
    },
}

export const SalesSlice = createSlice({
    name: "Sales",
    initialState,
    reducers: {
        setNewSales: (state, {payload}) => {
            state.newSales = payload;
        },
        setNewSalesNewProduct: (state, {payload}) => {
            state.newSalesNewProduct = payload;
        },
        setNewSalesExtraData: (state, {payload}) => {
            state.newSales.extraData = {...state.newSales.extraData, ...payload};
        },
        resetNewSales: (state) => {
            state.newSales = state.newSalesInitialValue;
            state.salesDiscountObject = initialSalesDiscountObject;
        },

        setNewQuotations: (state, {payload}) => {
            state.newQuotations = payload;
        },
        setNewQuotationNewProduct: (state, {payload}) => {
            state.newQuotationNewProduct = payload;
        },
        resetNewQuotations: (state) => {
            state.newQuotations = state.newQuotationInitialValue;
            state.quotationDiscountObject = initialQuotationDiscountObject;
        },

        setEditQuotationNewProduct: (state, {payload}) => {
            state.editQuotationNewProduct = payload;
        },
        resetEditQuotations: (state) => {
            state.editQuotations = state.newQuotationInitialValue;
            state.quotationDiscountObject = initialQuotationDiscountObject;
        },
        setNewPrimerAiUrl: (state, {payload}) => {
            state.newPrimerAiUrl = payload;
        },
        resetNewPrimerAiUrl: (state) => {
            state.newPrimerAiUrl = state.newPrimerAiUrlInitialValue;
        },

        // View sale
        setEditSales: (state, action) => {
            const tabKey = action?.meta?.tabKey;
            if (!tabKey) { // Update by open _id
                for (const key in state.editSales) {
                    if (state.editSales[key]._id === action.payload._id) {
                        state.editSales[key] = action.payload;
                        break;
                    }
                }
            } else {
                state.editSales[tabKey] = action.payload;
            }
        },

        // Edit Quotation
        setEditQuotations: (state, action) => {
            const tabKey = action?.meta?.tabKey;
            if (!tabKey) { // Update by open _id
                for (const key in state.editQuotations) {
                    if (state.editQuotations[key]._id === action.payload._id) {
                        state.editQuotations[key] = action.payload;
                        break;
                    }
                }
            } else {
                state.editQuotations[tabKey] = action.payload;
            }
        },
        setViewSalePeppolEdit: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.viewSalePeppolEdit[tabKey] = action.payload;
        },
        setViewSalePeppolEditOldData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.viewSalePeppolEditOldData[tabKey] = action.payload;
        },

        setSearchSales: (state, {payload}) => {
            state.searchSales = payload;
        },
        setSearchQuotations: (state, {payload}) => {
            state.searchQuotations = payload;
        },
        setSearchAIQuotations: (state, {payload}) => {
            state.searchAIQuotations = payload;
        },
        setAiQuotationsRequestData: (state, {payload}) => {
            state.aiQuotationsRequestData = payload;
        },
        setAiQuotationsResponseData: (state, {payload}) => {
            state.aiQuotationsResponseData = payload;
        },
        setTotalItemsSS: (state, {payload}) => {
            state.totalItemsSS = payload;
        },
        setTotalItemsQQ: (state, {payload}) => {
            state.totalItemsQQ = payload;
        },
        setTotalItemsAIQQ: (state, {payload}) => {
            state.totalItemsAIQQ = payload;
        },
        setPerPageSS: (state, {payload}) => {
            state.perPageSS = payload;
        },
        setPerPageQQ: (state, {payload}) => {
            state.perPageQQ = payload;
        },
        setPerPageAIQQ: (state, {payload}) => {
            state.perPageAIQQ = payload;
        },

        setSalesTemplates: (state, {payload}) => {
            state.salesTemplates = payload;
        },
        setSelectedSalesTemplate: (state, {payload}) => {
            state.selectedSalesTemplate = payload;
        },
        setQuotationsTemplates: (state, {payload}) => {
            state.quotationsTemplates = payload;
        },
        setSelectedQuotationsTemplates: (state, {payload}) => {
            state.selectedQuotationsTemplate = payload;
        },
        setCorelatedDocumentsList: (state, {payload}) => {
            state.corelatedDocumentsList = payload;
        },
        setSelectedPrimerAiUrl: (state, {payload}) => {
            state.selectedPrimerAiUrl = payload;
        },
        setPrimerAiUrlTemplates: (state, {payload}) => {
            state.primerAiUrlTemplates = payload;
        },
        setSelectedPrimerAiUrlTemplates: (state, {payload}) => {
            state.selectedPrimerAiUrlTemplates = payload;
        },
        setPrintLayout: (state, {payload}) => {
            state.printLayout = payload;
        },
        setSalesDiscountObject: (state, {payload}) => {
            state.salesDiscountObject = payload;
        },
        setNewSaleClientCustomData: (state, {payload}) => {
            state.newSaleClientCustomData = payload;
        },
        setQuotationDiscountObject: (state, {payload}) => {
            state.quotationDiscountObject = payload;
        },
        setNewQuotationClientCustomData: (state, {payload}) => {
            state.newQuotationClientCustomData = payload;
        },
        setEditQuotationClientCustomData: (state, {payload}) => {
            state.editQuotationClientCustomData = payload;
        },

        // Sales Monthly Turnover Report
        initSalesMonthlyTurnoverReport: (state, {payload}) => {
            state.salesMonthlyTurnoverReportData[payload.tabKey] = {...initSalesMonthlyTurnoverResponseData};
            state.salesMonthlyTurnoverReportRequestData[payload.tabKey] = {...initSalesMonthlyTurnoverRequestData};
        },
        setSalesMonthlyTurnoverReportData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.salesMonthlyTurnoverReportData[tabKey] = action.payload;
        },
        setSalesMonthlyTurnoverReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.salesMonthlyTurnoverReportRequestData[tabKey] = action.payload;
        },

        // Sales Balance Sheet
        initSalesBalanceSheet: (state, {payload}) => {
            state.salesBalanceReportData[payload.tabKey] = [];
            state.salesBalanceReportRequestData[payload.tabKey] = {...salesBalanceSheetInitRequestData};
        },
        setSalesReportData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.salesBalanceReportData[tabKey] = action.payload;
        },
        setSalesReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.salesBalanceReportRequestData[tabKey] = action.payload;
        },

        // Sales My Data Report
        setForceRefreshMyDataSalesReport: (state, {payload}) => {
            state.forceRefreshMyDataSalesReport = payload;
        },
        setSalesMyDataReportRequestData: (state, {payload}) => {
            state.salesMyDataReportRequestData = payload;
        },
        setSalesMyDataReportData: (state, {payload}) => {
            state.salesMyDataReportData = payload;
        },
        setSalesMyDataReportClientsData: (state, {payload}) => {
            state.salesMyDataReportClientsData = payload;
        },
        setSalesMyDataReportTotals: (state, {payload}) => {
            state.salesMyDataReportTotals = payload;
        },

        // Primer Client Payments
        setPrimerClientPaymentsRequestData: (state, {payload}) => {
            state.primerClientPaymentsRequestData = payload;
        },

        // Emron Client Payments
        setEmronClientPaymentsRequestData: (state, {payload}) => {
            state.emronClientPaymentsRequestData = payload;
        },

        // Client Payments Report
        initClientPaymentsReport: (state, {payload}) => {
            state.clientPaymentsReportRequestData[payload.tabKey] = {...initClientPaymentsReportRequestData};
            state.clientPaymentsReportResponseData[payload.tabKey] = {...initClientPaymentsReportResponseData};
        },
        setClientPaymentsReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.clientPaymentsReportRequestData[tabKey] = action.payload;
        },
        setClientPaymentsReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.clientPaymentsReportResponseData[tabKey] = action.payload;
        },

        // Sales Graphic Report
        initSalesGraphicReport: (state, {payload}) => {
            state.salesGraphicReportRequestData[payload.tabKey] = {...initSalesGraphicReportRequestData};
            state.salesGraphicReportResponseData[payload.tabKey] = {...initSalesGraphicReportResponseData};
        },
        setSalesGraphicReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.salesGraphicReportRequestData[tabKey] = action.payload;
        },
        setSalesGraphicReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.salesGraphicReportResponseData[tabKey] = action.payload;
        },

        // Correlated DCL Data
        setCorrelatedDclData: (state, {payload}) => {
            state.correlatedDclData = payload;
        },
        setCorrelatedVisitData: (state, {payload}) => {
            state.correlatedVisitData = payload;
        },
        setCorrelatedSaleData: (state, {payload}) => {
            state.correlatedSaleData = payload;
        }
    },
});

export const {
    setNewSales,
    resetNewSales,
    setNewSalesExtraData,
    setNewSalesNewProduct,
    setSearchSales,
    setPerPageSS,
    setTotalItemsSS,
    setSalesTemplates,
    setSelectedSalesTemplate,
    setEditSales,

    // Quotations
    setNewQuotations,
    resetNewQuotations,
    resetEditQuotations,
    setNewQuotationNewProduct,
    setEditQuotationNewProduct,
    setSearchQuotations,
    setSearchAIQuotations,
    setPerPageQQ,
    setPerPageAIQQ,
    setTotalItemsQQ,
    setTotalItemsAIQQ,
    setAiQuotationsRequestData,
    setAiQuotationsResponseData,
    setEditQuotations,
    setQuotationDiscountObject,
    setNewQuotationClientCustomData,
    setEditQuotationClientCustomData,
    setQuotationsTemplates,
    setSelectedQuotationsTemplates,

    // PrimerAiUrl
    setNewPrimerAiUrl,
    resetNewPrimerAiUrl,
    setPrimerAiUrlTemplates,
    setSelectedPrimerAiUrlTemplates,
    setSelectedPrimerAiUrl,

    setPrintLayout,
    setSalesDiscountObject,
    setNewSaleClientCustomData,

    // Sales Monthly Turnover Report
    initSalesMonthlyTurnoverReport,
    setSalesMonthlyTurnoverReportData,
    setSalesMonthlyTurnoverReportRequestData,

    // Sales Balance Sheet
    initSalesBalanceSheet,
    setSalesReportData,
    setSalesReportRequestData,

    // Sales My Data Report
    setForceRefreshMyDataSalesReport,
    setSalesMyDataReportRequestData,
    setSalesMyDataReportTotals,
    setSalesMyDataReportData,
    setSalesMyDataReportClientsData,

    // View sale peppol quick edit
    setViewSalePeppolEdit,
    setViewSalePeppolEditOldData,

    // Primer Client Payments
    setPrimerClientPaymentsRequestData,

    // Emron Client Payments
    setEmronClientPaymentsRequestData,

    // Client Payments Report
    initClientPaymentsReport,
    setClientPaymentsReportRequestData,
    setClientPaymentsReportResponseData,

    // Sales Graphic Report
    initSalesGraphicReport,
    setSalesGraphicReportRequestData,
    setSalesGraphicReportResponseData,

    setCorrelatedDclData,
    setCorrelatedVisitData,
    setCorrelatedSaleData,
} = SalesSlice.actions;
